module.exports = __webpack_public_path__ + "static/media/successful-partnerships-bg.b3de80e0.jpg";